import React from 'react';
import Button from '@mui/material/Button';
import { useAuth } from './AuthProvider';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
    button: {
        width: '100px',
    }
}));

export const AuthButton = () => {
    const { user, login, logout } = useAuth();
    const styles = useStyles();

    return (
        <Button className={styles.button} color="inherit" onClick={user ? logout : login}>
            {user ? 'Sign out' : 'Sign in'}
        </Button>
    );
};